import { memo, useEffect, useState } from 'react';

import { recordPageGA } from '../../../modules/ga';

import { Collapse } from 'antd';
import { COMPETITION_STATUS } from '../../../modules/competition';
import { disconnectSocket, joinRoom } from '../../../modules/websocket';
import CompetitionStage4 from '../CompetitionDetails/CompetitionStage4';
import StudentCompetitionStage2 from './StudentCompetitionStage2';
import StudentCompetitionStage3 from './StudentCompetitionStage3';

const { Panel } = Collapse;

let intervalId = null;


const StudentCompetitionDetails = ({ isLoading, lang, theCompetition, theClass, onExpireTime, user, addStudent, onSaveResponse }) => {

    const [avatar, setAvatar] = useState(0);

    // Registro en Google Analytics
    useEffect(() => {
        recordPageGA('/competition-details');

        if (theCompetition) {
            joinRoom(`mt-${theCompetition.id}`);
        }

        return () => {
            disconnectSocket();
            if (intervalId) {
                clearInterval(intervalId);
            }
        };

    }, []);

    useEffect(() => {
        console.log('theCompetition changed:', theCompetition);

        if (theCompetition) {
            const isInCompetition = theCompetition.participants ? theCompetition.participants.find(p => p.uid == user.id) : false;
            if (isInCompetition) setAvatar(isInCompetition.avatar);
            else setAvatar(user.avatar);
        }
    }, [theCompetition]);

    const handleExpireTime = () => {
        const currentExercise = theCompetition.currentExercise || 0;
        if (currentExercise) onExpireTime(`e${currentExercise}`);
    }

    const handleReady = () => {
        const studentData = {
            uid: user.id,
            name: user.name,
            avatar: avatar
        };

        addStudent(theCompetition.id, studentData);
    }


    console.log('StudentCompetitionDetails theCompetition: ', theCompetition);

    if (theCompetition && theClass && !isLoading) {
        const isInCompetition = theCompetition.participants ? theCompetition.participants.find(p => p.uid == user.id) : false;

        return (
            <section className="class-details competition">
                {theCompetition.status == COMPETITION_STATUS.OPENED ? <StudentCompetitionStage2 lang={lang} theCompetition={theCompetition} handleReady={handleReady} avatar={avatar} updateAvatar={setAvatar} studentInCompetition={isInCompetition} /> : null}

                {theCompetition.status == COMPETITION_STATUS.PLAYING ? <StudentCompetitionStage3 lang={lang} theCompetition={theCompetition} handleExpireTime={handleExpireTime} user={user} saveResponse={onSaveResponse} /> : null}
                {theCompetition.status == COMPETITION_STATUS.FINISHED ? <CompetitionStage4 lang={lang} theCompetition={theCompetition} /> : null}


            </section>
        );
    } else return null;
};

export default memo(StudentCompetitionDetails);